import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { getAssetUrl } from "@/utils/assets"

export function MobileWelcomeScreen() {
  const navigate = useNavigate()
  const logoLight = getAssetUrl("auth-logo.png")
  const symbolSrc = getAssetUrl("symbol.svg")

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="flex flex-col items-center justify-center gap-2.5">
        <img src={symbolSrc} alt={"app-symbol"} className="h-[87px] w-[110px]" />
        <img src={logoLight} alt={"app-logo"} className=" w-[200px] h-10" />
      </div>
      <div className="mt-[82px]">
        <div className="text-center space-y-5">
          <h2 className="text-xl font-semibold leading-normal text-[#F2F0EBE6]">Welcome</h2>
          <p className="text-primary text-sm leading-[22px]">
            Let’s personalize your experience so rituals <br />
            feel more meaningful to you.
          </p>
        </div>

        <div className="w-full mt-7.5">
          <Button
            type="button"
            variant="primary"
            size="md"
            className="rounded-full uppercase text-sm font-semibold py-3.75 h-12.5"
            fullWidth
            onClick={() => navigate("/")}
          >
            Start Exploring
          </Button>
        </div>
      </div>
    </div>
  )
}
